import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { translationChunksConfig } from '@spartacus/assets';
import { CmsConfig, ConfigModule, provideConfig } from '@spartacus/core';
import { OutletPosition, provideOutlet } from '@spartacus/storefront';
import { ReportsDashboardComponent } from './reports-dashboard/reports-dashboard.component';


@NgModule({
  declarations: [ReportsDashboardComponent],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ReportBeforeLoginComponent: {
          component: ReportsDashboardComponent,
        },
      },
    } as CmsConfig)
  ],
  providers: [
    provideOutlet({
      id: 'ReportBeforeLoginSlot',
      position: OutletPosition.REPLACE,
      component: ReportsDashboardComponent,
    }),
    provideConfig({
      i18n: {
        backend: {
          loadPath: 'assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: translationChunksConfig,
      },
    }),
  ],
  exports: [ReportsDashboardComponent]
})
export class ReportsModule { }
